import { generationSettingStore } from "@entities/generation-setting";
import { onReconciled, refreshDeck, toUidMapping } from "@features/office";

/**
 * 走査の結果を設定の鍵の移行へ繋ぐ。
 *
 * 旧鍵（PowerPoint 発行の ID）と新鍵（アドイン発行の識別子）の対応が取れるのは、
 * 両方が揃っている走査の瞬間だけ。設定ストアは同期的に読み込まれるので、この配線が
 * 来るまで旧版のまま待っている。
 *
 * ここが app 層にあるのは、`entities/generation-setting` と `features/office` の
 * どちらから呼んでも循環参照になるため。両方を知ってよいのは上位だけ。
 *
 * 旧い鍵の設定があるときは、画面が開かれるのを待たずに走査する。画面の購読任せにすると、
 * ホームに留まったまま生成を始めた場合に旧版のまま残る。設定が空のファイルでは走査しない。
 * 1,170 図形へタグを書けばファイルが未保存になるので、触っていないファイルを汚さないため。
 * 設計: docs/notes/設計ノート/2026-08-31 設計ノート アドイン 生成設定の識別子.md
 */
export function wireUidMigration(): () => void {
    const off = onReconciled((report) => {
        if (!generationSettingStore.needsUidMigration()) return;
        // 旧鍵を読めない環境では対応表が空になる。そのまま移行すると要素の設定と担当の対象が
        // まとめて捨てられ、版だけ上がって二度と戻せない。読める環境で開き直すまで待つ。
        if (!report.creationIdAvailable) return;
        generationSettingStore.applyUidMapping(toUidMapping(report));
    });
    if (generationSettingStore.needsUidMigration()) void refreshDeck();
    return off;
}
